import {
    AcademicCapIcon,
    CalendarDaysIcon,
    ChatBubbleLeftRightIcon,
    ClockIcon,
    DocumentTextIcon,
    HeartIcon,
    IdentificationIcon,
    SunIcon,
} from '@heroicons/react/24/outline';
import { MIN_ADVANCE_DAYS } from '@/features/Vacations/utils/vacationStartDateRules';
import type { DpRequestCardDefinition } from './dpRequestsPage.types';

export const UPCOMING_SHOW_LABEL = (count: number) => `Mostrar outras solicitações (${count})`;
export const UPCOMING_HIDE_LABEL = 'Ocultar solicitações em breve';

export const UNAVAILABLE_BADGE = 'Indisponível';
export const COMING_SOON_BADGE = 'Em breve';

export const DP_REQUEST_CARDS: DpRequestCardDefinition[] = [
    {
        id: 'ferias',
        title: 'Solicitação de férias',
        description: 'Agende o período de descanso e venda de 1/3.',
        note: `Envie com no mínimo ${MIN_ADVANCE_DAYS} dias de antecedência`,
        icon: SunIcon,
        tabId: 'ferias',
        needsVacationModule: true,
    },
    {
        id: 'day-off',
        title: 'Day-off de aniversário',
        description: 'Uma folga no dia do seu aniversário, de segunda a sexta. Precisa da aprovação do gestor Raro e do cliente.',
        note: 'Exclusivo para CLT',
        icon: CalendarDaysIcon,
        path: 'solicitacoes/day-off',
        needsVacationModule: true,
    },
    {
        id: 'hora-extra',
        title: 'Hora extra',
        description: 'Registre horas extras já aprovadas pelo gestor, para compensação ou pagamento.',
        note: 'Anexe o PDF do e-mail de aprovação',
        icon: ClockIcon,
        path: 'solicitacoes/hora-extra',
    },
    {
        id: 'raro-invest',
        title: 'Raro Invest',
        description: 'Peça o reembolso de R$ 100,00 por mês, enviando a nota de negociação de títulos.',
        note: 'Exclusivo para CLT',
        icon: AcademicCapIcon,
        path: 'solicitacoes/raro-invest',
        needsVacationModule: true,
    },
    {
        id: 'beneficios',
        title: 'Benefícios',
        description: 'Inclusão, mudança ou saída do plano de saúde.',
        icon: HeartIcon,
        path: 'solicitacoes/beneficios',
    },
    {
        id: 'dados',
        title: 'Atualização de dados',
        description: 'Endereço, contato, estado civil, filhos, conta bancária e formação.',
        note: 'Alterações bancárias valem para a próxima folha',
        icon: IdentificationIcon,
        path: 'solicitacoes/dados',
    },
    {
        id: 'holerite',
        title: 'Holerite e declarações',
        description: 'Segunda via de holerite, informe de rendimentos, declaração de vínculo.',
        icon: DocumentTextIcon,
    },
    {
        id: 'outros',
        title: 'Outros assuntos',
        description: 'Folha, declarações ou qualquer dúvida. Converse com o DP pelo chamado.',
        icon: ChatBubbleLeftRightIcon,
        path: 'solicitacoes/outros',
    },
];
